
<el-container class="screen-parameters screen-parameters-integration screen-parameters-fullHeight services">
  <el-row class="services-panel black-inputs">
    <el-col :span="20" :offset="2" class="services-container">
      <div class="nav-toggle" @click="showHideScreenIntegration">
        <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
      </div>
      <div class="screen-title">Integration</div>
      <div class="screen-block">
        <el-row :gutter="20">
          <el-col :span="5" style="height: 40px;">
            <div class="screen-sub-title">Integration</div>
          </el-col>
          <el-col :span="9" style="height: 40px;">Ancien formulaire</el-col>
          <el-col :span="1" style="height: 40px;"></el-col>
          <el-col :span="9" style="height: 40px;">Nouveau formulaire</el-col>

          <!-- Web -->
          <el-col :span="5" class="screen-label">Web : </el-col>
          <el-col :span="9" class="screen-fake-input">{{ getLink('web') }}<i @click="copylink('web')"
              class="el-icon-document-copy"></i></el-col>
          <el-col :span="1"></el-col>
          <el-col :span="9" class="screen-fake-input">{{ getLink('web', true) }}<i @click="copylink('web', true)"
              class="el-icon-document-copy"></i></el-col>

          <!-- Instagram -->
          <el-col :span="5" class="screen-label">Instagram : </el-col>
          <el-col :span="9" class="screen-fake-input">{{ getLink('instagram') }}<i @click="copylink('instagram')"
              class="el-icon-document-copy"></i></el-col>
          <el-col :span="1"></el-col>
          <el-col :span="9" class="screen-fake-input">{{ getLink('instagram', true) }}<i
              @click="copylink('instagram', true)" class="el-icon-document-copy"></i></el-col>

          <!-- Contenu caché -->
          <template v-if="showMore">
            <el-col :span="5" class="screen-label">Facebook : </el-col>
            <el-col :span="9" class="screen-fake-input">{{ getLink('facebook') }}<i @click="copylink('facebook')"
                class="el-icon-document-copy"></i></el-col>
            <el-col :span="1"></el-col>
            <el-col :span="9" class="screen-fake-input">{{ getLink('facebook', true) }}<i
                @click="copylink('facebook', true)" class="el-icon-document-copy"></i></el-col>

            <el-col :span="5" class="screen-label">Google : </el-col>
            <el-col :span="9" class="screen-fake-input">{{ getLink('google') }}<i @click="copylink('google')"
                class="el-icon-document-copy"></i></el-col>
            <el-col :span="1"></el-col>
            <el-col :span="9" class="screen-fake-input">{{ getLink('google', true) }}<i
                @click="copylink('google', true)" class="el-icon-document-copy"></i></el-col>

            <el-col :span="5" class="screen-label">Yelp : </el-col>
            <el-col :span="9" class="screen-fake-input">{{ getLink('yelp') }}<i @click="copylink('yelp')"
                class="el-icon-document-copy"></i></el-col>
            <el-col :span="1"></el-col>
            <el-col :span="9" class="screen-fake-input">{{ getLink('yelp', true) }}<i @click="copylink('yelp', true)"
                class="el-icon-document-copy"></i></el-col>

            <el-col :span="5" class="screen-label">TripAdvisor : </el-col>
            <el-col :span="9" class="screen-fake-input">{{ getLink('tripadvisor') }}<i
                @click="copylink('tripadvisor')" class="el-icon-document-copy"></i></el-col>
            <el-col :span="1"></el-col>
            <el-col :span="9" class="screen-fake-input">{{ getLink('tripadvisor', true) }}<i
                @click="copylink('tripadvisor', true)" class="el-icon-document-copy"></i></el-col>

            <el-col :span="5" class="screen-label">Influenceur : </el-col>
            <el-col :span="9" class="screen-fake-input">{{ getLink('influencer') }}<i @click="copylink('influencer')"
                class="el-icon-document-copy"></i></el-col>
            <el-col :span="1"></el-col>
            <el-col :span="9" class="screen-fake-input">{{ getLink('influencer', true) }}<i
                @click="copylink('influencer', true)" class="el-icon-document-copy"></i></el-col>

            <el-col :span="5" class="screen-label">Iframe : </el-col>
            <el-col :span="19" class="screen-fake-input">{{ getLink('iframe') }}<i @click="copylink('iframe')"
                class="el-icon-document-copy"></i></el-col>
          </template>

          <!-- Bouton Voir Plus -->
          <el-col :span="24" class="text-center" style="margin-top: 20px;">
            <el-button type="text" @click="toggleShowMore">{{ showMore ? 'Voir moins' : 'Voir plus' }}</el-button>
          </el-col>
        </el-row>
      </div>
    </el-col>
  </el-row>
</el-container>
